import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/MultiplePlanScaleEditWizard.scss";
import autobind from "autobind-decorator";
import ScaleIcon from "../assets/images/scale-64x64.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {setNotification} from "../redux/actions/general/notification";
import {withRouter} from "react-router";
import MultiplePlanScaleEditForm from "../forms/wizard_multiple_plan_scale_edit/MultiplePlanScaleEditForm";
import {listPlanUploads, multipleEditPlanScale} from "../redux/actions/table/plan_uploads";
import {listWorkingSetPlans} from "../redux/actions/table/working_set_plans";

@mapStateToProps((state) => ({
	plan_ids: _.get(state.table, "plan_uploads.wizard_multiple_plan_scale_edit"),
}))
@withRouter
class MultiplePlanScaleEditWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		const {plan_ids} = this.props;

		return validateForm(
			multipleEditPlanScale(plan_ids, _.get(formData, 'scale')).then(() => {
				if(this.props.match.path == "/stages/:stage/plans/uploads") {
					listPlanUploads(this.props.match.params.stage);

					setTableParams('plan_uploads', {
						selected_rows: []
					});
				} else if(this.props.match.path == "/stages/:stage/plans/working") {
					listWorkingSetPlans(this.props.match.params.stage);

					setTableParams('working_set_plans', {
						selected_rows: []
					});
				}

				setNotification(__("Multiple plan scale have been saved."));

				this.props.onClose();
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('Multiple Edit Plan Scale')}</span>
						<span>{__('Choose the scale for selected plans')}</span>
					</div>
					<div className={styles.right}>
						<ScaleIcon />
					</div>
				</div>
				<div className={styles.body}>
					<MultiplePlanScaleEditForm onSubmit={this._handleSubmit} />
				</div>
			</>
		);
	}
}

export default MultiplePlanScaleEditWizard;
